import { paths } from '../routes';

/**
 * Where the all-tenant view opens — from the "Master mode" entry in the tenant
 * dropdown and as the start page after login (DefaultLanding). One rule for
 * both (PO, 2026-11-02): a master opens on "Mandanten".
 *
 * Service and manager users with several tenants also see the all-tenant view
 * (`useCanViewAllTenants`) but not the master-only "Mandanten" page, which
 * would send them to /unauthorized; they keep opening on the bookings.
 */
export const masterModeEntryPath = (isMaster: boolean): string =>
    (isMaster ? paths.masterTenants : paths.masterBookings);
